"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseILeadTypeData = void 0;
const ilead_type_feedback_settings_1 = require("./ilead-type-feedback-settings");
function parseILeadTypeData(data) {
    if (data.feedback !== null && typeof data.feedback === 'object')
        data.feedback = (0, ilead_type_feedback_settings_1.parseILeadTypeFeedbackSettings)(data.feedback);
    return data;
}
exports.parseILeadTypeData = parseILeadTypeData;
